import React from 'react'
import { Typography, withStyles } from '@material-ui/core'
import { componentBoxHideAction } from 'src/reducers/component-box/action'
import styles from '../styles'
import { CoreButton } from 'src/components/core'

const ImportButtons = props => {
  const { handleImport, dispatch, uploadedFile, classes } = props
  return (
    <div className={classes.modalContent__buttons}>
      <CoreButton
        onClick={() => dispatch(componentBoxHideAction())}
        variant="text"
        color="secondary"
        size="small"
      >
        Cancel
      </CoreButton>
      <CoreButton
        disabled={!uploadedFile}
        onClick={() => handleImport()}
        size="small"
      >
        Import
      </CoreButton>
    </div>
  )
}

export default withStyles(styles)(ImportButtons)
